<script setup>
const props = defineProps({
    row: {
        type: Object,
        default: undefined,
    },
})
</script>
<template>
    <div class="relative p-fl-4 w-full">
        <div class="" v-html="row.content.content" />
    </div>
</template>
<style>
    .tiptap-list-item p {
        display: inline;
    }
</style>